import Skeleton from "@mui/material/Skeleton"
import TableCell from "@mui/material/TableCell"

import TableRow from "@mui/material/TableRow"
import React from "react"
import { useGetAllInterviewsQuery } from "../../../api/InterviewsApi"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../app/store"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { useSearchParams } from "react-router-dom"

const InterwiewersHeader = () => {
  const header = [
    "ID",
    "ФИО собеседующего",
    "Ссылка по индивидуальному типу",
    "Ссылка по групповому типу",
    "Тэг в ТГ",
  ]

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgb(55, 55, 55)"
            : "rgba(225, 225, 225, 1)",
      }}
    >
      {header.map((item) => (
        <TableCell
          key={item}
          sx={{
            // whiteSpace: item?.length > 20 ? "normal" : "nowrap",
            fontSize: "14px",

            minWidth: item.length > 30 ? "200px" : "auto",
            fontWeight: "bold",
            lineHeight: "1.2",
            ":first-of-type": {
              borderRadius: "4px 0 0 4px",
            },
            ":last-of-type": {
              borderRadius: "0px 4px 4px 0px",
            },
            height: "57px",
          }}
        >
          {item}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default InterwiewersHeader
